const _SET_NETWORK = "SET_NETWORK";

export const networkActions = Object.freeze({
  SET_NETWORK: _SET_NETWORK,
});

export function setNetwork(network) {
  return { type: _SET_NETWORK, network };
}
